import smart_lunch from "images/smart_lunch.jpg";
import carte from "images/carte.jpg";

import catering from "images/catering.jpg";
import homecooking from "images/homecooking.jpg";

import piatto1 from "images/piatto1.jpg";
import piatto2 from "images/piatto2.jpg";
import piatto3 from "images/piatto3.jpg";
import piatto4 from "images/piatto4.jpg";
import piatto5 from "images/piatto5.jpg";
import piatto7 from "images/piatto7.jpg";
import piatto8 from "images/piatto8.jpg";
import piatto9 from "images/piatto9.jpg";

import rabar1 from "images/rabar/_CLO1848.jpeg";
import rabar2 from "images/rabar/_CLO1875.jpeg";
import rabar3 from "images/rabar/_CLO1888.jpeg";
import rabar4 from "images/rabar/_CLO1937.jpeg";
import rabar5 from "images/rabar/_CLO1983.jpeg";
import rabar6 from "images/rabar/_CLO1999.jpeg";
import rabar7 from "images/rabar/_CLO2010.jpeg";
import rabar8 from "images/rabar/_CLO2434.jpeg";
import rabar10 from "images/rabar/_CLO2518.jpeg";

const entry = {
	pageTitle: "Rabarbaro | Ristorante e Bar a Piacenza – Tra Lavaggi e Bouquet",
	description:
		"A Piacenza, un ristorante nato da una lavanderia e un bar cresciuto tra i fiori. Scegli da che parte entrare: mangi o bevi? O entrambi?",
	section: "Entry",
	linkName: "Home",
	route: "/home",
};

const home = {
	pageTitle: "Rabarbaro Ristorante a Piacenza | Ex Lavanderia, Cucina Gagliarda",
	description:
		"Cucina stagionale in una ex lavanderia nel cuore di Piacenza. Rabarbaro è un ristorante informale, con piatti vivi e idee poco stirate.",
	section: "Rabarbaro",
	linkName: "Rabarbaro",
	route: "/rabarbaro",
};

const rabar = {
	pageTitle: "Rabar Bar Piacenza | Dove i fiori non si annaffiano, si shakerano",
	description:
		"Una volta ci crescevano le margherite. Ora ci crescono i gin tonic. Benvenuto da Rabar: botanico dentro, sbocciato fuori.",
	section: "Rabar",
	linkName: "Rabar",
	route: "/rabar",
};

const pranzi = {
	pageTitle: "Pranzo a Piacenza? Vieni da Rabarbaro | Cucina Veloce, Mai Banale",
	description:
		"Ogni pranzo è una scusa per scappare dall’ufficio. Da Rabarbaro trovi piatti veloci, stagionali e mai noiosi. Ex lavanderia, oggi cucina che respira.",
	section: "Pranzi",
	linkName: "Pranzi",
	route: "/pranzi",
};

const cene = {
	pageTitle:
		"Cena a Piacenza? Rabarbaro è il Posto Giusto | Ex Lavanderia, Cene Sporche di Gusto",
	description:
		"A cena in una ex lavanderia dove il tovagliolo è facoltativo ma il gusto obbligatorio. Rabarbaro è il ristorante di Piacenza dove le serate sanno di stagionale e un po’ strano.",
	section: "Cene",
	linkName: "Cene",
	route: "/cene",
};

const heroCarousel = [
	{
		title: "Rabarbaro",
		subtitle: "Lavanderia di Cucina Gagliarda",
		callToAction: "Prenota un tavolo",
		action:
			"https://wa.me/393335468741?text=Ciao,%20vorrei%20prenotare%20un%20tavolo%20da%20Rabarbaro.",
	},
	{
		title: "Rabarbaro",
		subtitle: "Lavanderia di cucina confortevole.",
		callToAction: "Prenota un tavolo",
		action:
			"https://wa.me/393335468741?text=Ciao,%20vorrei%20prenotare%20un%20tavolo%20da%20Rabarbaro.",
	},
];

const serviziSection = {
	title: "I nostri servizi",
	subtitle: "A tua scelta",
};

const servizi = [
	{
		key: "servizio1",
		image: smart_lunch,
		alt: "Pranzo da Rabarbaro a Piacenza, cucina stagionale in ex lavanderia",
		name: "Pranzo in lavanderia?!",
		when: "Dal Martedì al Venerdì, a pranzo.",
		shortDescription:
			"Pranza con le nostre proposte smart lunch 15, 25 e tasting lunch.",
		longDescription:
			"<ul><li>Smart Lunch 15 euro</li><li>Acqua, calice di vino, entrée con pane e focaccia fatti in casa, un piatto a scelta dal menù che cambia giornalmente e viene detto a voce, insalatina di frutta e piccolo dolce, caffè</li></ul><ul><li>Smart Lunch 25 euro</li><li>Acqua, calice di vino, entrée con pane e focaccia fatti in casa, due piatti del	menù detto a voce che cambia giornalmente, insalatina di frutta e piccolo dolce, caffè</li></ul><ul><li>Tasting Lunch</li><li>Piccolo menù degustazione a sorpresa che attinge ai piatti della carta serale	proponendo tapas, primo, secondo, dolce	</li><li>Vino signature RBR BOLLICINA o RBR GUTTURNIO BARRICA 2016</li></ul>",
		animation: "fadeInLeft",
		cta: "Scopri la proposta dei pranzi",
		href: "/pranzi",
	},
	{
		key: "servizio2",
		image: carte,
		alt:
			"Servizio cena da Rabarbaro a Piacenza, cucina stagionale in ex lavanderia",
		name: "Cena in lavanderia?!",
		when: "Dal Martedì al Venerdì, a cena. Sabato, tutto il giorno",
		shortDescription:
			"Il nostro menù cambia ogni settimana in base al mercato e alla stagionalità.",
		longDescription:
			'<ul><li><span class="title">Tutto. Cambia. Sempre.</span>Anche il nostro menù.<br/>Oggi è così, domani chissà.</li><li><br/>Oltre alla carta, tre percorsi per chi non ha paura di farsi sorprendere:</li><li>GOLDENRBR – Lusso? No. Oro? Nemmeno. Solo piatti che brillano da soli.</li><li>TRADIZIONE RIVISTA. Un po’. – Tipo la nonna, ma con il Wi-Fi.</li><li>PERCORSO VEGAN – Niente facili battute. Solo roba buona, verde e tosta.</li><li>Mangi, ridi, torni. E sarà tutto diverso.</li></ul>',
		animation: "fadeInRight",
		cta: "Scopri la proposta delle cene",
		href: "/cene",
	},
];

const reviewsSection = {
	title: "La voce dei clienti",
	subtitle: "Dicono di noi",
};

const reviews = [
	{
		key: "review1",
		author: "Realizzo SRLS",
		date: new Date(2024, 1, 12).toLocaleDateString(),
		description:
			"Una fantastica scoperta nel cuore di Piacenza. Ambiente rivisitato e raffinato. Piatti degni di stelle Michelin a prezzi più che onesti. Abbiamo pranzato di sabato parcheggiando paraticanente a pochi metri. Ottima esperienza culinaria. Complimenti sia agli chef che a tuttO lo staff di sala. Torneremo sicuramente con amici",
	},
	{
		key: "review2",
		author: "Davide Pessina",
		date: new Date(2023, 8, 20).toLocaleDateString(),
		description:
			"Taverna Rabarbaro è una realtà giovane e dinamica in una città dove l’offerta culinaria è sempre troppo tradizionalista. Propongono una cucina contemporanea di piatti ben presentati e con ingredienti ricercati, che soddisfa gli occhi ed il palato. Il locale è arredato originalmente, ricavato in una ex lavanderia e da quel senso di intimità che non si trova spesso. Ottima e alternativa selezione di amari, rhum e whisky per concludere.",
	},
	{
		key: "review3",
		author: "Niccolò Cordani",
		date: new Date(2023, 4, 7).toLocaleDateString(),
		description:
			"Piatti sempre azzeccati sia come qualità che come gusto. Servizio estremamente cordiale, scherzoso per una serata informale e altrettanto educata. Location ricercata e stilosa. Torneremo sicuramente…",
	},
	{
		key: "review4",
		author: "Andrea Baricchi",
		date: new Date(2022, 11, 3).toLocaleDateString(),
		description:
			"Il nostro menù cambia ogni settimana in base al mercato e alla stagionalità. Le costanti sono la pasta fresca fatta in casa, varietà di carne, pesce, vegetariano e scelte vegan.",
	},
];

const piattiSection = {
	title: "Se sì, non abbiamo fatto apposta",
	subtitle: "Li abbiamo fatti noi?",
};

const piatti = [
	{
		name: "Piatto 2",
		image: piatto2,
		alt: "Piatto di cucina stagionale con ingredienti freschi da Rabarbaro",
	},
	{
		name: "Piatto 3",
		image: piatto3,
		alt:
			"Piatto gourmet da Rabarbaro con ingredienti selezionati e presentazione creativa",
	},
	{
		name: "Piatto 4",
		image: piatto4,
		alt: "Tempor incididunt ut labore",
	},
	{
		name: "Piatto 1",
		image: piatto5,
		alt: "Risotto mantecato con ingredienti freschi e una presentazione elegante",
	},
	{
		name: "Piatto 2",
		image: piatto7,
		alt: "Tartare di carne preparata con cura e servita con condimenti freschi",
	},
	{
		name: "Piatto 3",
		image: piatto8,
		alt: "Pasta fresca fatta a mano con condimento stagionale da Rabarbaro",
	},
	{
		name: "Piatto 4",
		image: piatto9,
		alt: "Antipasto creativo da Rabarbaro, piatto ricco di colori e sapori",
	},
	{
		name: "Piatto",
		image: piatto1,
		alt: "Dessert gourmet da Rabarbaro, un equilibrio di dolcezza e creatività",
	},
];

const immagini_rabar = [
	{
		name: "Rabar 1",
		image: rabar1,
		alt: "Cocktail preparato al bar Rabar",
	},
	{
		name: "Rabar 2",
		image: rabar2,
		alt: "Bicchiere di cocktail servito al bar Rabar",
	},
	{
		name: "Rabar 3",
		image: rabar3,
		alt: "Drink servito con decorazioni fresche al bar Rabar",
	},
	{
		name: "Rabar 4",
		image: rabar4,
		alt: "Banco del bar con drink pronti da servire",
	},
	{
		name: "Rabar 5",
		image: rabar5,
		alt: "Cocktail con ingredienti freschi al bar Rabar",
	},
	{
		name: "Rabar 6",
		image: rabar6,
		alt: "Aperitivo con stuzzichini al bar Rabar",
	},
	{
		name: "Rabar 7",
		image: rabar7,
		alt: "Barista mentre prepara un drink al bar Rabar",
	},
	{
		name: "Rabar 8",
		image: rabar8,
		alt: "Tavolo con cocktail e drink al bar Rabar",
	},
	{
		name: "Rabar 10",
		image: rabar10,
		alt: "Cocktail classico servito al bar Rabarbaro",
	},
];

const eventiPage = {
	pageTitle: "I nostri eventi",
	description: "Catering, rinfreschi, matrimoni e homecooking.",
	section: "Eventi",
	linkName: "Eventi",
	route: "/eventi",
};

const serviziPage = {
	pageTitle: "I nostri servizi",
	description: "Pranzo, cena ed eventi privati.",
	section: "Servizi",
	linkName: "Servizi",
	route: "/servizi",
};

const eventi = [
	{
		name: "Catering e fingerfood",
		description:
			"Rendi grande ogni occasione con il nostro catering, richiedi un preventivo per il tuo evento.",
		image: catering,
	},
	{
		name: "Homecooking",
		description: "Tutto quello che ti piace del Rabarbaro, a casa tua.",
		image: homecooking,
	},
];

const storiaPage = {
	pageTitle: "Storia",
	description: "Scopri la storia di Rabarbaro",
	section: "Storia",
	linkName: "Storia",
	route: "/storia",
};

const storia = {
	title: "",
	text:
		"Rabarbaro - Laundry Bistrot - è una Ex lavanderia industriale; L’insegna ”Tintoria” rimane nella Piccola Saletta, dove un tempo si lavoravano i colori. La Scritta “Lavanderia” invece, si trova all’ingresso, dove il signor Paolo accoglieva i clienti assieme alla moglie Elda. Affianco, la sala principale, in origine “deposito” di indumenti appesi sulle serpentine. La cucina odierna del Bistrot era il fulcro dell’attività, con enormi lavatrici, ferri da stiro, macchine a vapore, tinozze per panni e assi di marmo, ancora oggi esposti e utilizzati, memori di un passato non dimenticato. Oltre che essere un attività storica, è stata per molti abitanti della piazza e del quartiere luogo di ritrovi, feste e incontri nel retrobottega, il cortiletto interno. Rabarbaro vuole continuare questa novella, cucinando dove prima si lavava e sbicchierando dove prima si stirava e si rinvigoriva un colore di un abito da festa mondana, conservando e accudendo quella convivialità che da sempre fa parte di questo piccolo spazio. Rabarbaro è storia, è cambiamento radicato nel buono e sincero. Com’era. Com’è.",
};

const contattiPage = {
	pageTitle: "Contatti",
	description: "Informazioni e richieste",
	section: "Contatti",
	linkName: "Contatti",
	route: "/contatti",
};

const contatti = {
	email: "tavernarabarbaro@gmail.com",
	phone: "+39 333 54 68 741",
	address: "Piazza Cittadella 9, Piacenza (PC)",
	addressSpecifics: "In pieno centro, di fronte a Palazzo Farnese.",
};

export {
	entry,
	home,
	rabar,
	pranzi,
	cene,
	heroCarousel,
	serviziSection,
	servizi,
	piattiSection,
	piatti,
	immagini_rabar,
	reviewsSection,
	reviews,
	eventiPage,
	eventi,
	serviziPage,
	storiaPage,
	storia,
	contattiPage,
	contatti,
};
